import type { TUserRole } from '~/types/user';

/**
 * Стабильный URL для QR фестиваля 4Л.
 * Нельзя SSR-редиректить сразу на /profile/: на сервере нет authSession
 * (он в localStorage), поэтому auth middleware выкидывает на /?auth=client,
 * а после гидрации — снова в ЛК. Редирект только на клиенте, см. pages/fest4l.vue.
 */
export const FEST4L_PATH = '/fest4l/';

/** Куда вести залогиненного пользователя с кампанийного QR. */
export function resolveOwnerCabinetPath(role: TUserRole | null | undefined): string {
  if (role === 'doctor') {
    return '/profile-doctor/';
  }
  if (role === 'clinic') {
    return '/profile-clinic/';
  }
  return '/profile/';
}
